import { i18n, i18nPlurals } from "../../domain/i18n.js";

export default {
  [i18nPlurals.brands["0"]]: 'marche',
  [i18nPlurals.brands["1"]]: 'marca',
  [i18nPlurals.brands["2"]]: 'marche',

  [i18n.generic.authorizedBy]: 'authorized.by',
  [i18n.generic.brands]: '{count} [brands]',

  [i18n.alt.authorizedBySeal]: '(authorized.by)',
  [i18n.alt.tuvSeal]: '(TÜV Saarland ShopIdent)',

  [i18n.menu.checkAuthorizations.caption]: 'Verifica autorizzazione',
  [i18n.menu.imprint.caption]: 'Informazione legale',
  [i18n.menu.imprint.link]: 'https://www.authorized.by/impressum/',
  [i18n.menu.privacyPolicy.caption]: 'Privacy',
  [i18n.menu.privacyPolicy.link]: 'https://www.authorized.by/datenschutz/',

  [i18n.header.texts.full.isAuthorized1]: '{url}',
  [i18n.header.texts.full.isAuthorized2]: 'è un partner online autorizzato',
  [i18n.header.texts.full.isAuthorized2_t0NotApproved]: 'Questo sito è nuovo per <a href="https://www.authorized.by/" target="_blank">authorized.by</a> e in attesa di approvazione per essere autorizzato da Brands',
  [i18n.header.texts.full.isAuthorized2_t0NoBrands]: 'Questo sito è nuovo per <a href="https://www.authorized.by/" target="_blank">authorized.by</a> e in attesa di autorizzazione da parte di Brands',
  [i18n.header.texts.full.isAuthorized3]: 'di questi {brands}',
  [i18n.header.texts.full.brands]: '{count} [brands]:',
  [i18n.header.texts.brandLink.multiple]: '{brandName} + {count} altre marche',
  [i18n.header.texts.brandLink.two]: '{brandName} + 1 altra marca',
  [i18n.header.texts.brandLink.one]: '{brandName}',

  [i18n.contents.texts.lastVerified]: 'Autorizzato ultima volta',
  [i18n.contents.texts.lastVerified_t0NotApproved]: '<a href="https://app.authorized.by/" target="_blank">>Awaiting Approval</a>',
  [i18n.contents.texts.lastVerified_t0NoBrands]: '<a href="https://app.authorized.by/" target="_blank">>Awaiting Authorization</a>',
  [i18n.contents.texts.tuvMember]: 'authorized.by | TÜV Saarland Group',
  [i18n.contents.texts.t0Message]: "Torna presto per i marchi autorizzati!",

  [i18n.contents.texts.originalityConfirmedTitle]: "Originalità confermata",
  [i18n.contents.texts.originalityConfirmedText]: "{url} garantisce espressamente l'originalità di questo prodotto.",
  [i18n.contents.texts.authRetailerTitle]: "Commerciante autorizzato",
  [i18n.contents.texts.authRetailerText]: "{url} è appositamente autorizzato della marca {brand} a vendere questo prodotto online ed è un partner fidato della marca.",
  [i18n.contents.texts.shopCheckTitle]: 'Identità verificata',
  [i18n.contents.texts.shopCheckText]: 'I dettagli dell´azienda sull´identità del fornitore del negozio {url} sono stati controllati l´ultima volta il {date} come parte della procedura TÜV Saarland ShopIdent.',

  [i18n.contents.texts.shopCheckTitle_brandSponsored]: 'Acquisti sicuri',
  [i18n.contents.texts.shopCheckText_brandSponsored]: '{url} soddisfa i requisiti specifici di {brand} ed è un partner fidato della marca.',

  [i18n.contents.texts.originalityConfirmedTitle_d2c]: "Negozio ufficiale del marchio",
  [i18n.contents.texts.originalityConfirmedText_d2c]: "{url} è il negozio ufficiale del marchio e opera per conto di {brand}.",
  [i18n.contents.texts.authRetailerTitle_d2c]: "Diretto dal produttore",
  [i18n.contents.texts.authRetailerText_d2c]: "{url} offre prodotti di marca direttamente dal produttore {brand}.",
  [i18n.contents.texts.shopCheckTitle_d2c]: 'Identità verificata',
  [i18n.contents.texts.shopCheckText_d2c]: 'I dettagli dell´azienda sull´identità del fornitore del negozio {url} sono stati controllati l´ultima volta il {date} come parte della procedura TÜV Saarland ShopIdent.',
  [i18n.contents.texts.shopCheckTitle_noTuv_d2c]: 'Acquisti sicuri',
  [i18n.contents.texts.shopCheckText_noTuv_d2c]: '{url} soddisfa i requisiti specifici di {brand} ed è un partner fidato della marca.',

  [i18n.footer.showCertificate]: 'VISUALIZZA CERTIFICATO',
};
